import React, { useMemo } from 'react';
import { toast } from 'react-toastify';
import styles from './Notification.module.scss';
import { ErrorLinkProps, ErrorNotification, InfoNotification, SuccessNotification } from './Notification';
import { ReactComponent as CloseButton } from '../../../assets/icons/cross-gray.svg';

export interface NotificationOptionsProps {
  link?: string,
  linkText?: string,
  caption?: string
}

const options = {
  className: styles.toastContainer,
  closeButton: <CloseButton className={styles.close}/>
}
const info = (message: string) => toast(<InfoNotification message={message}/>, options);

const errorOptions = {
  ...options,
  className: styles.toastContainerError,
}
const error = (message: string, caption?: string, link?: ErrorLinkProps) =>
  toast(<ErrorNotification message={message} caption={caption} link={link}/>, errorOptions);

const successOptions = {
  ...options,
  className: styles.toastContainerSuccess,
}
const success = (message: string) => toast(<SuccessNotification message={message}/>, successOptions);

export const useNotification = () => {
  return useMemo( () =>({
    info,
    success,
    error
  }), []);
}